// #genai GuestAccess Redux action types and action creators.
// Tracks every API flag in the guest / shared-resource sign-in flow.

export const SET_GUEST_RESOURCE = 'GUEST_ACCESS/SET_GUEST_RESOURCE';
export const SET_GUEST_USER_INFO = 'GUEST_ACCESS/SET_GUEST_USER_INFO';
export const SET_GUEST_VERIFICATION = 'GUEST_ACCESS/SET_GUEST_VERIFICATION';
export const SET_GUEST_VERIFIED = 'GUEST_ACCESS/SET_GUEST_VERIFIED';
export const SET_GUEST_FLOW_PHASE = 'GUEST_ACCESS/SET_GUEST_FLOW_PHASE';
export const SET_GUEST_ERROR = 'GUEST_ACCESS/SET_GUEST_ERROR';
export const RESET_GUEST = 'GUEST_ACCESS/RESET_GUEST';
export const SET_GUEST_HAS_ACCESS = 'GUEST_ACCESS/SET_GUEST_HAS_ACCESS';

// ─── Action Creators ───────────────────────────────────────────────────────

/**
 * Stores the combined result of validateResourcePath + requestPreAccessToken.
 * isResourceShared is true only when BOTH APIs confirm the resource is shared.
 * The preAccessToken here is informational — the actual token has already been written
 * to localStorage under PRE_ACCESS_TOKEN_KEY by SharedStartupGate.
 * @param {{
 *   isResourceShared: boolean,
 *   isPreAccessTokenOk: boolean,
 *   preAccessToken: string,
 *   resourceShareId: string,
 *   resourceId: string,
 *   appCode: string,
 *   resourcePath: string
 * }} payload
 */
export const setGuestResource = (payload) => ({ type: SET_GUEST_RESOURCE, payload });

/**
 * Stores the result of checkIsEvUser.
 * @param {{ isEvUser, loginId, email }} payload
 */
export const setGuestUserInfo = (payload) => ({ type: SET_GUEST_USER_INFO, payload });

/**
 * Stores the result of sendEmailVerification.
 * @param {{ verificationId, emailSent }} payload
 */
export const setGuestVerification = (payload) => ({ type: SET_GUEST_VERIFICATION, payload });

/**
 * Stores the result of pollEmailVerification — marks the guest as fully verified.
 * @param {{ isVerified, customAuthToken }} payload
 */
export const setGuestVerified = (payload) => ({ type: SET_GUEST_VERIFIED, payload });

/**
 * Updates the current phase of the guest flow.
 * Phases: 'idle' | 'validating' | 'legacy' | 'emailInput' | 'sendingEmail' |
 *         'verifyEmail' | 'polling' | 'verified' | 'error'
 * @param {string} phase
 */
export const setGuestFlowPhase = (phase) => ({ type: SET_GUEST_FLOW_PHASE, payload: phase });

/**
 * Stores an error message / object.
 * @param {string|null} error
 */
export const setGuestError = (error) => ({ type: SET_GUEST_ERROR, payload: error });

/** Resets the entire GuestAccess store to its initial state. */
export const resetGuest = () => ({ type: RESET_GUEST });

/**
 * Stores the result of checkResourceAccess.
 * @param {{ hasAccess: boolean|null, resourceAccessAuditId: string|null }} payload
 *   hasAccess              – null = not yet checked; true = access granted; false = denied. #genai
 *   resourceAccessAuditId  – ID from checkResourceAccess response, used for backend status updates.
 */
export const setGuestHasAccess = (payload) => ({ type: SET_GUEST_HAS_ACCESS, payload });
